ixModuleRouting("impactx.saperrormessage", {
    "/sapprserrorlist": {
        template: "<ixa-sap-prserror-list></ixa-sap-prserror-list>",
        templateUrl: "modules/saperrormessage/templates/sapprserrorlist.html",
        controller: "SAPPRSErrorListController",
        controllerAs: "sapPRSErrorListController",
        process: "SAPErrorRequest",
        workspace: "admin",
    },
    "/sapdnherrorlist": {
        template: "<ixa-sap-dnherror-list></ixa-sap-dnherror-list>",
        process: "SAPErrorDelivery",
        workspace: "admin",
    },
});
